import { HashMap } from 'shared/types/commonView';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@mui/material';
import { checkboxControlRootSx } from './styles';
import type { CheckboxControlProps } from './types';

export function CheckboxControl({
  filter,
  localSetter,
  localValue,
  disabled,
}: CheckboxControlProps): ReactElement {
  const intl = useIntl();
  const { labelId, labels } = filter;

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    localSetter({
      ...localValue,
      [event.target.name]: event.target.checked,
    });
  };

  return (
    <Box sx={checkboxControlRootSx}>
      <FormControl variant="standard" component="fieldset" disabled={disabled}>
        <FormLabel component="legend">
          {formatTranslation(intl, unsafeTranslationKey(labelId))}
        </FormLabel>
        <FormGroup>
          {Object.keys(localValue).map((key) => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  color="primary"
                  checked={localValue[key]}
                  onChange={handleChange}
                  name={key}
                />
              }
              label={formatTranslation(
                intl,
                unsafeTranslationKey(labels?.[key] ?? key)
              )}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
}
